export const environmentLocal = {
  name: 'local',
  production: false,
  sentry:
    'https://5a8a7ae424d5357cdbefa684b8fa89ca@o508829.ingest.us.sentry.io/4507748293476352',
  mixpanel: '1050fbb4460815e8403ee76d371cc350',
  googleAnalyticsTrackingId: 'G-XN6X7FFY9S',
  facebookAppId: '489291613816841',
  recaptchaSiteKey: '6Ldh4yQqAAAAAA3VM7jj1GyhzJ-5txb0xtzV-9fL',
};
